<template lang="pug">

  div

    dialog-user-plan-manager(ref="modalUserPlanManager")

    v-navigation-drawer(
      id="core-navigation-drawer"
      v-model="drawer"
      mini-variant
      expand-on-hover
      :dark="true"
      :right="$vuetify.rtl"
      mobile-breakpoint="960"
      app
      width="260"
      style="min-width: 80px;"
      v-bind="$attrs"
    )

      .v-image__image.v-image__image--preload.v-image__image--cover.menuBackground

      v-list-item(two-line)
        v-list-item-content
          v-list-item-title(:class="['text-uppercase', 'font-weight-regular', 'display-2']")
            span
              .sosMenuLogo(:style="{ backgroundImage: 'url(' + logo + ')' }")

      v-divider.mb-1

      v-list(nav dense)
        item-group(v-if="profile" :key="userSession.uid")

      v-divider.mb-2

      v-list(expand nav)
        div
        template(v-for="(item, i) in menuItems")

          template(v-if="item.type === 'page'")

            item-group(v-if="item.children" :key="`group-${i}`" :item="item")
            item(v-else :key="`item-${i}`" :item="item")

          template(v-else-if="item.type === 'dialog'")

            v-list-item(:key="`item-${i}`" @click="openDialog(item)")
              v-list-item-icon
                v-icon(v-text="'mdi-account-search-outline'")
              v-list-item-content(style="flex-wrap: nowrap;")
                v-list-item-title(v-text="'Planos'")

</template>

<script>

  import { mapState } from 'vuex'

  import { freeVersion, logo } from '@/constants'
  import { hasPartnerFeature, FEATURE } from '@/config/partnerFeatureFlags'

  import DialogUserPlanManager from '@/modals/DialogUserPlanManager'
  import ItemGroup from '@/components/base/ItemGroup'
  import Item from '@/components/base/Item'

  // import moment from 'moment'
  // import 'moment/locale/pt-br'
  // moment.locale('pt-BR')

  export default {
    name: 'Drawer',

    components: {
      'dialog-user-plan-manager': DialogUserPlanManager,
      'item-group': ItemGroup,
      'item': Item,
    },

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      logo,
      items: [],
    }),

    computed: {
      ...mapState({
        userSession: state => state.app.userSession,
        plans: state => state.app.plans,
      }),

      menuItems ()
      {
        const isPlanManagerActive = !!this.userSession.userCapabilities.planManager === true

        const menuItems = [
          { type: 'page', title: 'Grupos', to: '/admin/grupos', icon: 'mdi-account-group', active: true },
          { type: 'page', title: 'Usuários', to: '/admin/usuarios', icon: 'mdi-table-account', active: true },
          { type: 'page', title: 'Séries', to: '/admin/series', icon: 'mdi-content-duplicate', active: true },
          { type: 'page', title: 'Perfil', to: '/admin/perfil', icon: 'mdi-account-circle-outline', active: false, exact: true },
        ]

        if (!freeVersion) menuItems.push({ type: 'page', title: 'Assinatura', to: '/admin/assinatura', icon: 'mdi-credit-card', active: false, exact: true })
        if (isPlanManagerActive) menuItems.push({ type: 'dialog', title: 'Planos', to: 'gerenciar_planos', icon: 'mdi-account-search-outline', active: false, exact: true })

        if (hasPartnerFeature(FEATURE.NOTIFICATION_CENTER)) menuItems.push({ type: 'page', title: 'Notificações', to: '/admin/central-de-notificacoes', icon: 'mdi-bell', active: false, exact: true })

        return menuItems.filter(menuItem => !!menuItem)
      },

      drawerIsOpen () {
        return this.$store.state.app.drawer
      },

      routeName () {
        return this.$route.path
      },

      drawer: {
        get () {
          return this.$store.state.app.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },

      profile () {
        return {
          avatar: this.userSession.userProfile.img,
          group: '/admin',
          title: !!this.userSession.loading === true ? 'Carregando...' : this.userSession.userProfile.nome,
          plano: { nome: this.userSession.planName.name, validade: false },
          children: [],
        }
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
    },

    methods: {
      openDialog (item) {
        // [24/01/25] console.log('::: OPEN DIALOG:', item)

        if (item.to === 'gerenciar_planos') this.$refs.modalUserPlanManager.open()
      },

      goToScreen (route, index) {
        const { items } = this

        this.$router.push(route)

        items.map((item, indice) => {
          if (indice === index) {
            items[indice].active = true
          } else {
            items[indice].active = false
          }
        })
      },
    },
  }

</script>

<style lang="sass">

  @import '~vuetify/src/styles/tools/_rtl.sass'

  .item-container
    flex-direction: column
    padding-bottom: 10px

  .btn-drawer-visible
    justify-content: flex-start
    border-width: 0

  .btn-container
    border-width: 0
    flex-direction: row

  .btn-drawer-close
    min-width: 0 !important

  .user-img
    border-radius: 50%

  .user-img-drawer-visible
    width: 50px
    height: 50px
    border-radius: 50%

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px

</style>
